import React, { useState, useEffect, useContext, createContext } from 'react';
import { useWhiteLabel } from './useWhiteLabel';
import { BrandingContext } from '../contexts/ContractContext';

const WhiteLabelAccountContext = createContext(null);

const usingAIGBranding = ['aig', 'arw', 'DTC', 'APPLE', null, undefined];

const WhiteLabelController = ({ children }) => {
    const context = useContext(BrandingContext);
    const { clientId } = context;

    const [isLoading, setIsLoading] = useState(true);
    const [account, setAccount] = useState(clientId || null);

    const brandingComplete = useWhiteLabel(account); // returns bool

    useEffect(() => {
        // set clientId and resolve if data present
        if (clientId) {
            setAccount(clientId);
        }

        setIsLoading(false);
    }, [clientId]);

    const needsSkinning = !usingAIGBranding.includes(account) && !brandingComplete;

    // FOR DEBUGGING
    // if (needsSkinning || isLoading) return <div>{`skinning... needsSkinning: ${needsSkinning}, isLoading: ${isLoading}`}</div>    // FOR DEBUGGING
    if (needsSkinning || isLoading) return null;

    return <WhiteLabelAccountContext.Provider value={account}>{children}</WhiteLabelAccountContext.Provider>;
};

export { WhiteLabelController, WhiteLabelAccountContext };
